/**
 * Ícones de linha (stroke = currentColor) — fiéis ao Claude Design (Modelo A).
 * Substituem os emojis coloridos da navegação por glifos sutis e neutros: o ativo
 * herda a cor verde do `.ativo`, os demais ficam em `--text-suave`. 24px por padrão.
 */
export type NomeIcone =
  | "grid"
  | "home"
  | "library"
  | "register"
  | "seguros"
  | "doc"
  | "kit"
  | "timeline"
  | "calendar"
  | "plus"
  | "config"
  | "user"
  | "atendimento";

const PATHS: Record<NomeIcone, JSX.Element> = {
  grid: (
    <>
      <rect x="4" y="4" width="6.5" height="6.5" rx="1.6" />
      <rect x="13.5" y="4" width="6.5" height="6.5" rx="1.6" />
      <rect x="4" y="13.5" width="6.5" height="6.5" rx="1.6" />
      <rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.6" />
    </>
  ),
  home: (
    <>
      <path d="M4 11.5 12 5l8 6.5" />
      <path d="M6 10.5V19h12v-8.5" />
      <path d="M10 19v-4.5h4V19" />
    </>
  ),
  library: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="3" />
      <path d="M9 8h6M9 12h6M9 16h3" />
    </>
  ),
  register: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="M10 9l5 3-5 3z" fill="currentColor" stroke="none" />
    </>
  ),
  seguros: (
    <>
      <path d="M12 3.5 19 6v5.2c0 4-2.8 6.9-7 8.3-4.2-1.4-7-4.3-7-8.3V6z" />
      <path d="M9 12l2.2 2.2L15.5 10" />
    </>
  ),
  doc: (
    <>
      <path d="M7 3h7l4 4v14H7z" />
      <path d="M14 3v4h4" />
      <path d="M10 12h5M10 16h5" />
    </>
  ),
  kit: (
    <>
      <rect x="3" y="8" width="18" height="11" rx="2" />
      <path d="M9 8V6.5A2.5 2.5 0 0 1 11.5 4h1A2.5 2.5 0 0 1 15 6.5V8" />
      <path d="M3 13h18" />
    </>
  ),
  timeline: (
    <>
      <path d="M4 18V6M4 14h6M4 9h11" />
      <circle cx="12" cy="14" r="1.6" fill="currentColor" stroke="none" />
      <circle cx="17" cy="9" r="1.6" fill="currentColor" stroke="none" />
    </>
  ),
  calendar: (
    <>
      <rect x="4" y="5" width="16" height="16" rx="2.5" />
      <path d="M8 3v4M16 3v4M4 10h16" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  config: (
    <>
      <path d="M4 8h8M16 8h4M4 16h4M12 16h8" />
      <circle cx="14" cy="8" r="2.2" />
      <circle cx="8" cy="16" r="2.2" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="3.4" />
      <path d="M5.5 19a6.5 6.5 0 0 1 13 0" />
    </>
  ),
  // Balão de conversa — modo Atendimento (ADR-24). Mesmo peso de traço dos
  // demais; o "rabicho" fica na base esquerda para não competir com o glifo.
  atendimento: (
    <>
      <path d="M4.5 6.2a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v7.4a2 2 0 0 1-2 2H9.4L5.6 19.2a.5.5 0 0 1-.85-.36V15.6a2 2 0 0 1-.25-.98z" />
      <path d="M8.6 9.2h6.8" />
      <path d="M8.6 12.1h4.3" />
    </>
  ),
};

export function Icone({
  name,
  size = 24,
  sw = 1.7,
}: {
  name: NomeIcone;
  size?: number;
  sw?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[name]}
    </svg>
  );
}
